var map = {
	"./algeria.png": "2bc4",
	"./america.png": "85b3",
	"./angola.png": "0159",
	"./argentina.png": "182e",
	"./australia.png": "844f",
	"./austria.png": "306d",
	"./belgium.png": "f640",
	"./brasil.png": "6c99",
	"./canada.png": "bef9",
	"./chile.png": "5bef",
	"./china.png": "c839",
	"./colombia.png": "bc47",
	"./congo.png": "76d4",
	"./denmark.png": "778f",
	"./ecuador.png": "f7d1",
	"./egypt.png": "b69c",
	"./ethiopia.png": "a678",
	"./fiji.png": "0f3f",
	"./finland.png": "c8d8",
	"./flag_roulette_anime.gif": "abfa",
	"./france.png": "a3a8",
	"./germany.png": "6a9f",
	"./india.png": "a098",
	"./indonesia.png": "b91c",
	"./iran.png": "0d52",
	"./ireland.png": "7b1d",
	"./israel.png": "93a7",
	"./italy.png": "b556",
	"./japan.png": "1297",
	"./kenya.png": "b5c7",
	"./korea.png": "ddfd",
	"./malaysia.png": "e825",
	"./mexico.png": "e6ba",
	"./nederland.png": "ed7e",
	"./newzealand.png": "e37c",
	"./norway.png": "9dbc",
	"./pakistan.png": "696a",
	"./papuanewguinea.png": "d899",
	"./paraguay.png": "7854",
	"./philippines.png": "8061",
	"./poland.png": "8c6c",
	"./russia.png": "0897",
	"./saudiarabia.png": "58e2",
	"./singapore.png": "f238",
	"./southafrica.png": "c8eb",
	"./spain.png": "e216",
	"./sweden.png": "8851",
	"./switzerland.png": "0981",
	"./thailand.png": "731f",
	"./turkey.png": "1414",
	"./uk.png": "3cff",
	"./venezuela.png": "c9b4",
	"./zimbabwe.png": "8e8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "428a";